import type { ReactNode } from 'react'

import './FeatureItem.css'

type FeatureItemProps = {
  icon: ReactNode
  title: string
  description: string
  inverse?: boolean
  compact?: boolean
}

export default function FeatureItem({ icon, title, description, inverse = false, compact = false }: FeatureItemProps) {
  return (
    <article className={`feature-item ${inverse ? 'feature-item--inverse' : ''} flex gap-3 ${compact ? 'items-start' : 'items-center'}`}>
      <span aria-hidden="true" className={`feature-item__icon grid shrink-0 place-items-center ${inverse ? 'feature-item__icon--inverse' : ''} ${compact ? 'feature-item__icon--compact' : ''}`}>
        {icon}
      </span>
      <div>
        <h3 className="feature-item__title text-sm font-extrabold leading-tight min-[900px]:text-[16px]">{title}</h3>
        <p className="feature-item__description mt-1 text-[11px] leading-[1.25] min-[900px]:text-[10px]">{description}</p>
      </div>
    </article>
  )
}
